import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "slides" }
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = { class: "slides" }
const _hoisted_4 = ["src"]

import { onBeforeUnmount, onMounted, ref } from 'vue';
	import { dataDomain } from '@/config';

	
export default /*#__PURE__*/_defineComponent({
  props: {
    defaultAlt: null,
    photos: null
  },
  setup(__props: any) {

const props = __props as {
		defaultAlt: string,
		photos: Array<string>
	}

	

	const flexSliderMain = ref(null);
	let $flexSliderMain = ref(null);
	const flexSliderThumbs = ref(null);
	let $flexSliderThumbs = ref(null);

	const isFlexsliderAvailable = typeof (window as any).$ !== 'undefined' && typeof (window as any).$.flexslider !== 'undefined';

	const vehiclePhotos = props.photos.map((p: string) => -1 !== p.indexOf('http') ? `${p}` : `${dataDomain}${p}`);

	onMounted(() => {
		if (isFlexsliderAvailable){
			$flexSliderMain.value = (window as any).$(flexSliderMain.value);
			($flexSliderMain.value as any)?.flexslider({
				animation: 'slide',
				animationLoop: false,
				controlNav: false,
				slideshow: false,
				sync: '.uv-gallery-thumbs',
				start: function(slider: any) {
					slider.removeClass('loading');
				}
			});
			$flexSliderThumbs.value = (window as any).$(flexSliderThumbs.value);
			($flexSliderThumbs.value as any)?.flexslider({
				animation: 'slide',
				animationLoop: false,
				asNavFor: '.uv-gallery-main',
				controlNav: false,
				itemMargin: 0,
				itemWidth: 100,
				slideshow: false
			});
		}
	});
	onBeforeUnmount(() => {
		if (isFlexsliderAvailable){
			($flexSliderMain.value as any)?.flexslider('destroy');
			($flexSliderThumbs.value as any)?.flexslider('destroy');
		}
	});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      class: "uv-gallery-main flexslider loading",
      ref_key: "flexSliderMain",
      ref: flexSliderMain
    }, [
      _createElementVNode("ul", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(vehiclePhotos), (photo) => {
          return (_openBlock(), _createElementBlock("li", { key: photo }, [
            _createElementVNode("div", null, [
              _createElementVNode("img", {
                src: photo,
                alt: __props.defaultAlt
              }, null, 8, _hoisted_2)
            ])
          ]))
        }), 128))
      ])
    ], 512),
    _createElementVNode("div", {
      class: "uv-gallery-thumbs flexslider",
      ref_key: "flexSliderThumbs",
      ref: flexSliderThumbs
    }, [
      _createElementVNode("ul", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(vehiclePhotos), (photo) => {
          return (_openBlock(), _createElementBlock("li", { key: photo }, [
            _createElementVNode("div", null, [
              _createElementVNode("img", {
                src: photo,
                role: "button",
                "aria-label": "Select thumb"
              }, null, 8, _hoisted_4)
            ])
          ]))
        }), 128))
      ])
    ], 512)
  ]))
}
}

})